import styled from 'styled-components';

export const AccessItemStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0 0 0;
`;

export const AccessItemLeftContainer = styled.div`
  display: flex;
  gap: 40px;
`;

export const ReadAccess = styled.div`
  width: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EditAccess = styled.div`
  width: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
